import { z } from "zod";

export enum RecontractingVariant {
  CUSTOMERADHOC = "CUSTOMER_ADHOC",
  OPERATORADHOC = "OPERATOR_ADHOC",
  CAMPAIGN = "CAMPAIGN",
  SAVEDESK = "SAVEDESK",
  ACCORD = "ACCORD",
}

export const RecontractingRequestEnumSchema = z.nativeEnum(RecontractingVariant);
export type RecontractingRequestEnum = z.infer<typeof RecontractingRequestEnumSchema>;
